import React from "react";
import { XIcon, CheckIcon, ArrowDownIcon } from "lucide-react";
import { beforeItems, afterItems } from "../data/content";
import { CtaButton } from "./CtaButton";
export function TransformationSection() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" data-id="element-307" data-mp="2wwm3nyf3z64w">
      <div className="mx-auto max-w-5xl" data-id="element-308" data-mp="2ryt1dggxew9w">
        <div className="text-center" data-id="element-309" data-mp="2rxremeqjslcc">
          <p className="text-sm font-bold uppercase tracking-wider text-gold-dark" data-id="element-310" data-mp="2s0x1dnbpfb4w">The transformation</p>
          <h2 className="mt-3 font-serif text-[30px] font-black leading-tight text-ink sm:text-5xl" data-id="element-311" data-mp="2j68z861fe9kb">
            From a man who reacts… to a man who <em className="text-gold-dark" data-id="element-312" data-mp="2e87i3qnk8kbh">understands his signals</em>
          </h2>
        </div>

        <div className="mt-10 grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr] md:gap-6" data-id="element-313" data-mp="2994bi1rxm61e">
          <div className="rounded-3xl border border-danger/20 bg-white p-6 sm:p-8" data-id="element-314" data-mp="2498926yvumny">
            <div className="flex items-center gap-3" data-id="element-315" data-mp="206v2jgcbakq4">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-danger text-white" data-id="element-316" data-mp="209hk88sx2gm2">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-317" data-mp="f99bvoq7l54l" />
              </span>
              <h3 className="font-serif text-2xl font-black text-danger" data-id="element-318" data-mp="k3ly26j2kuk1">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-319" data-mp="5b1xndnb116a">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink/80" data-id="element-320" data-mp="a9wrrbqq2c5p">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" strokeWidth={3} aria-hidden="true" data-id="element-321" data-mp="xzh9jrb533de" />
                  <span data-id="element-322" data-mp="12yaozp9zl4g7">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" data-id="element-323" data-mp="p387e4vs1qnk">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gold text-ink md:-rotate-90" data-id="element-324" data-mp="t0w85ok5idnd">
              <ArrowDownIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-325" data-mp="39t7fcectnzq6" />
            </span>
          </div>

          <div className="rounded-3xl border-2 border-success bg-success-soft p-6 sm:p-8" data-id="element-326" data-mp="1k9zfyepvnppm">
            <div className="flex items-center gap-3" data-id="element-327" data-mp="1kbtosunvjrdc">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-success text-white" data-id="element-328" data-mp="1fc7d4pnp2j6n">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-329" data-mp="1ail91lvljnmg" />
              </span>
              <h3 className="font-serif text-2xl font-black leading-tight text-success" data-id="element-330" data-mp="15kjosxmfpi9e">With the Protocol™</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-331" data-mp="11h51dlw61zlx">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] font-medium leading-snug text-ink" data-id="element-332" data-mp="wmhl2abbgbif">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-333" data-mp="rn4y7pkg34fu" />
                  <span data-id="element-334" data-mp="2lzckyfmm4f0j">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12" data-id="element-335" data-mp="2gzqc0idthkxj">
          <CtaButton label="I want the 28-day system" data-id="element-336" data-mp="2h1jf5np81n0s" />
        </div>
      </div>
    </section>;
}